import React, {useState} from 'react'
import IconButton from '@mui/material/IconButton'
import InfoIcon from '@mui/icons-material/Info'
import Popover from '@mui/material/Popover'
import styled from 'styled-components'
import {Typography} from '@mui/material'

const InfoPopover = ({body}) => {
    const [anchorEl, setAnchorEl] = useState(null)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const open = Boolean(anchorEl)
    const id = open ? 'info-popover' : undefined

    return (
        <div>
            <IconButton
                aria-describedby={id}
                color="primary"
                onClick={handleClick}>
                <InfoIcon />
            </IconButton>
            <StyledPopover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}>
                <Content>
                    <Typography variant="h3">Information</Typography>
                    <Typography
                        whiteSpace="pre-line"
                        lineHeight={1.8}
                        variant="subtitle1">
                        {body}
                    </Typography>
                </Content>
            </StyledPopover>
        </div>
    )
}

export default InfoPopover

const StyledPopover = styled(Popover)`
    .MuiPaper-root {
        background-color: #f1f1f1;
    }
`

const Content = styled.div`
    padding: 16px;
    h3 {
        font-size: 1.5em;
        margin-bottom: 8px;
    }
    p {
        font-size: 1em;
    }
`
